import React from 'react';
import '../../App.css';

export default function Services() {
  return <h1 className='services'>Crossy is a Map tool designed to bring people together. 
In a world where buzzing establishments and something new happening around every corner, it can be overwhelming to find the perfect hangout spot.<br />
Crossy plans to solve just that, our AI powered Suggestion feature uses real time data to find the best hangout spot depending on your budget, location and mood.</h1>;
}
